import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';

// import { Button, FormControlLabel, MenuItem, Radio, Typography } from 'material-ui';
import { InputLabel, Select as MSelect, Radio, MenuItem, TextField, Checkbox, FormControlLabel, Divider, Button, Paper, Typography, FormControl, FormHelperText, Icon, IconButton, Toolbar, AppBar } from 'material-ui';


import ReactTable from "react-table";
import axios from 'axios/index';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import Loader from "other-components/loader/loader";
import { withAlert } from 'react-alert';
import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import moment from 'moment';
import 'react-select/dist/react-select.css';
import Select from 'react-select';
import 'react-day-picker/lib/style.css';
import { confirmAlert } from 'react-confirm-alert';
import CloseIcon from '@material-ui/icons/Close';
import classNames from 'classnames';
import printjs from 'print-js';


const styles = theme => ({
    layoutRoot: {},
    paper: { padding: '10px' },
    input: {
        'margin-top': 0
    },
    dialogPaper: {
        minHeight: '70vh',
        maxHeight: '70vh',
    },
});


var transaction_date = null;
var date = null;
var due_date = null;
var amount = null;
var ledger_account_id = null;
var ledger_account_name = null;
var supplier = null;
var supplier_name = null;
var ref_number = null;
var doc_number = null;
var id = null;
var update_id = null;
var is_active = null;

class BillEntries extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            loading: true,
            supplierArray: [],
            ledgerAccArray: [],
            supplier: '',
            ledgerAcc: '',
            supplierEdit: '',
            supplierNameEdit: '',
            ledgerAccEdit: '',
            ledgerAccEditName: '',
            openComposeDialog: false,
            today: moment(new Date()).format("YYYY-MM-DD"),
            date: moment(new Date()).format("YYYY-MM-DD"),
            transaction_date: moment(new Date()).format("YYYY-MM-DD"),
            due_date: moment(new Date()).format("YYYY-MM-DD")
        };


        this.populateFileds();
        this.openNewCustomerDialog = this.openNewCustomerDialog.bind(this);
        this.closeNewCustomerDialog = this.closeNewCustomerDialog.bind(this);
        this.loadData();
        this.loadLedgerDetails();
        this.loadSupplierDetails();

    }

    // handleDateChange = name => event => {
    //     this.setState({ [name]: event.target.value });
    // };
    // handleDueDateChange = name => event => {
    //     this.setState({ [name]: event.target.value });
    // };
    // handleTransactionDateChange = name => event => {
    //     this.setState({ [name]: event.target.value });
    // };


    openNewCustomerDialog() {
        // this.setState({ loading: true });
        // this.setState({ expanded: 'panel1' });
        // this.clearContactPersons;
        this.setState({ openComposeDialog: true });
        // this.setState({ loading: false });
    }

    closeNewCustomerDialog() {
        this.setState({ openComposeDialog: false });
    }

    handleLedgerSupplier = (selectedOption) => {
        this.setState({
            supplier: selectedOption
        });
    }

    handleLedgerSupplierEdit = (selectedOption) => {
        // alert(selectedOption)
        this.setState({
            supplierEdit: selectedOption
        });
    }

    handleLedgerAcc = (selectedOption) => {
        this.setState({
            ledgerAcc: selectedOption
        });
    }

    handleLedgerAccEdit = (selectedOption) => {
        this.setState({
            ledgerAccEdit: selectedOption
        });
    }

    handleCloseEdit = () => {
        this.setState({ edit: false });
    };

    populateFileds() {

    }

    onEdit = (model) => {

        // if ("" == this.state.acc_type || null == this.state.acc_type || undefined == this.state.acc_type) {
        //     this.props.alert.error("Select Account Type");
        // } else {


        var dueDate = model.due_date;
        var date = model.date;
        var transaction_date = model.transaction_date;
        console.log(dueDate)
        var today = this.state.today;
        console.log(today);


        if (date < today) {
            this.props.alert.error("date can't be a past date");
        } else if (dueDate < today) {
            this.props.alert.error("due date can't be a past date");
        } else if (transaction_date < today) {
            this.props.alert.error("transaction date can't be a past date");
        } else {
            // console.log("feture date");
            this.updateBillEntries(model);

        }

    };

    updateBillEntries(model) {
        var ledger_id;
        var ledger_account_name;
        var supplier;
        var supplier_name;
        if (this.state.ledgerAccEdit.value == null) {
            ledger_id = this.state.ledgerAccEdit;
            ledger_account_name = this.state.ledgerAccEditName;
        } else {
            ledger_id = this.state.ledgerAccEdit.value;
            ledger_account_name = this.state.ledgerAccEdit.label;
        }

        if (this.state.supplierEdit.value == null) {
            supplier = this.state.supplierEdit;
            supplier_name = this.state.supplierNameEdit;
        } else {
            supplier = this.state.supplierEdit.value;
            supplier_name = this.state.supplierEdit.label;
        }




        const billObj = {
            ledger_id: ledger_id,
            // date: model.date,
            // doc_number: model.doc_number,
            transaction_date: model.transaction_date,
            referance_no: model.referance_no,
            due_date: model.due_date,
            supplier: supplier,
            supplier_name:supplier_name,
            ledger_account: ledger_account_name,
            amount: model.amount,
            id: model.id
        }

        console.log(billObj)



        // axios.post('http://localhost:5009/billEntries/updateBillEntries', billObj)
        axios.post(window.accountServer + '/billEntries/updateBillEntries', billObj)
            .then(res => {

                if (res.data.success) {
                    // alert("Success");
                    this.props.alert.success(" Ledger Account Details Updated Successfully.");
                    this.handleCloseEdit();
                    this.clearValue();
                    this.loadData();
                } else {
                    // alert('Ivalid Credentials');
                    this.props.alert.error("Error In Ledger Account Update.");
                }

            }).catch(function (error) {
                // alert("Error");
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });


    }

    onSubmit = (model) => {
        var dueDate = model.due_date;
        var date = model.date;
        var transaction_date = model.transaction_date;
        console.log(dueDate)
        var today = this.state.today;
        console.log(today);


        if (date < today) {
            this.props.alert.error("date can't be a past date");
        } else if (dueDate < today) {
            this.props.alert.error("due date can't be a past date");
        } else if (transaction_date < today) {
            this.props.alert.error("transaction date can't be a past date");
        } else {
            // console.log("feture date");
            this.saveBillEntries(model);

        }

    };

    saveBillEntries(model) {
        console.log("supplierArray: "+this.state.supplierArray);
        const billObj = {
            ledger_id: this.state.ledgerAcc.value,
            // date: model.date,
            // doc_number: model.doc_number,
            transaction_date: model.transaction_date,
            referance_no: model.referance_no,
            due_date: model.due_date,
            supplier: this.state.supplier.value,
            supplier_name:this.state.supplier.label,
            ledger_account: this.state.ledgerAcc.label,
            amount: model.amount
        }

        console.log(billObj)

        // axios.post('http://localhost:5009/billEntries/createBillEntries', billObj)
        axios.post(window.accountServer + '/billEntries/createBillEntries', billObj)
            .then(res => {

                if (res.data.success) {
                    // alert("Success");
                    this.props.alert.success("Ledger Account Details added Successfully.");
                    this.loadData();
                    this.closeNewCustomerDialog();
                    this.clearValue();
                    console.log('insertId', res.data.insertId);

                    // this.form.reset()   
                    
                    var billEntryReportDetails = {
                        billObj,
                        bill_entry_id : res.data.insertId
                    }
                    
                    
                    axios.post(window.reportServer+'/billEntryReport/get/billEntryReport', billEntryReportDetails)
                                //axios.post(window.accountServer + '/transactionLedger/bulkInsert ', transactionObj)
                                .then(response => {
                                    console.log(response)
                                    if (response.data.success = true) {
                                        //console.log("done..");

                                        var address = response.data.path;
                                         address = window.reportServer + "/" + address;
                                        // address = "http://localhost:2008/" + address;

                                        printjs({ printable: address, type: 'pdf', showModal: true })
                                        //console.log("done..");
                                    }
                                    this.clearValue()
                                }).catch(function (error) {
                                    console.log("err " + error);
                                    console.log("No internet connection or Internal error");
                                });



                } else {
                    // alert(res.data.message);
                    this.props.alert.error(res.data.message);
                }
            });


            


    }

    clearValue = () => {
        this.form.reset();
        this.setState({
            supplier: '',
            ledgerAcc: '',
            mainAccRef: '',
            date: moment(new Date()).format("YYYY-MM-DD"),
            transaction_date: moment(new Date()).format("YYYY-MM-DD"),
            due_date: moment(new Date()).format("YYYY-MM-DD"),
            mainAccName: ''
        });
    }

    loadData() {
        var resObj;
        // axios.get('http://localhost:5009/billEntries/getAllBillEntries')
        axios.get(window.accountServer + '/billEntries/getAllBillEntries')
            .then(response => {
                if (response.data.success) {
                    resObj = response.data.billEntries;
                    console.log(resObj)
                    this.appendToTable(resObj)
                }
            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

        // this.closeNewCustomerDialog();
    }

    appendToTable(billObj) {

        console.log(billObj)
        var data = [];
        var active;

        for (var i = 0; i < billObj.length; i++) {
            if (billObj[i].IS_ACTIVE == 1) {
                active = 'Active'
            } else {
                active = 'Inactive'

            }

            data.push({
                update_id: billObj[i].ID_BILL_ENTRIES,
                // id: "B-" + ledgerObj[i].ID_LEDGER_ACCOUNT,
                doc_number: billObj[i].ID_BILL_ENTRIES,
                ref_number: billObj[i].REFERENCE_NO,
                supplier: billObj[i].SUPPLIER,
                supplier_name: billObj[i].SUPPLIER_NAME,
                ledger_account_name: billObj[i].LEDGER_NAME,
                ledger_account_id: billObj[i].ID_LEDGER_ACCOUNT,
                amount: billObj[i].AMOUNT,
                due_date: billObj[i].DUE_DATE,
                date: billObj[i].DATE,
                transaction_date: billObj[i].TRANSACTION_DATE,
                is_active: billObj[i].IS_ACTIVE,
                active: active
            });

        }

        this.setState({ data: data });
        this.setState({ loading: false });
    }





    loadLedgerDetails() {
        var ledgerAccArray = [];
        // axios.get('http://localhost:5009/ledgerAccount/getExpencesLedgerAccountDetails')
        axios.get(window.accountServer + '/ledgerAccount/getExpencesLedgerAccountDetails')
            .then(response => {
                if (response.data.success) {
                    // resObj = response.data.ledgerAccountDetails;
                    if (response.data.ledgerAccountDetails.length == 0) {
                        this.setState({ ledgerAccArray: [], ledgerAcc: '' });
                    } else {
                        for (let i = 0; i < response.data.ledgerAccountDetails.length; i++) {
                            console.log("rrrr" + JSON.stringify(response.data.ledgerAccountDetails[i].ID_LEDGER_ACCOUNT));
                            ledgerAccArray.push({
                                value: response.data.ledgerAccountDetails[i].ID_LEDGER_ACCOUNT,
                                label: response.data.ledgerAccountDetails[i].NAME
                            });
                        }
                        this.setState({ ledgerAccArray: ledgerAccArray });

                    }
                }
            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    loadSupplierDetails() {
        var supplierArray = [];
        const suplierObj = {
            typeId: 1
        }
        // axios.post('http://192.168.8.138:5004/supplier/getSupplierByType',suplierObj)
        axios.post(window.inventoryServer + '/supplier/getSupplierByType', suplierObj)
            .then(response => {
                if (response.data.success) {
                    // resObj = response.data.ledgerAccountDetails;
                    if (response.data.result.length == 0) {
                        this.setState({ supplierArray: [] });
                    } else {
                        for (let i = 0; i < response.data.result.length; i++) {
                            console.log("rrrr" + JSON.stringify(response.data.result[i].ID_LEDGER_ACCOUNT));
                            supplierArray.push({
                                value: response.data.result[i].ID_SUPPLIER_PROFILE,
                                label: response.data.result[i].SUPPLIER_NAME
                            });
                        }
                        this.setState({ supplierArray: supplierArray });

                    }
                }
            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }


    componentWillMount() { }

    render() {
        const { classes } = this.props;

        var borderStyle = {
            'border-bottom': '4px solid darkgrey',
            'background-color': 'lightgrey',
            'border-style': 'inset'
        };

        if (this.state.loading) {
            return (<Loader />);
        }

        else {

            return (
                <div className="pl-8">
                    {/* <div className="p-8">
                        <h2>Create Ledger Account</h2>
                    </div> */}

                    <Toolbar className="flex w-full pt-24 px-12 ml-1920 bill-entry-margin">
                        <h2 className="w-full subtitle-color">
                       Bill Entries View
                        </h2>
                        <div className="px-12">
                            <Button
                                className="w-160"
                                type="button"
                                variant="raised"
                                color="secondary"
                                onClick={(ev) => {
                                    this.openNewCustomerDialog();
                                }}
                            >
                                Add Bill Entry
                                </Button>
                        </div>
                        <div className="px-12">
                            <Button
                                variant="raised"
                                color="default"
                            >
                                Help
                            </Button>
                        </div>
                    </Toolbar>




                    <Dialog className={classNames(classes.root, "z-10")} open={this.state.openComposeDialog} fullWidth maxWidth="md"  >
                        <AppBar className="flex w-full h-50 app-bar-size" position="static">
                            <Toolbar className="flex w-full">
                                <Typography className="w-full" variant="subheading" color="inherit">
                                    New Bill Entry
                          </Typography>
                                <IconButton className="" color="inherit" onClick={this.closeNewCustomerDialog} aria-label="Close">
                                    <CloseIcon />
                                </IconButton>
                            </Toolbar>
                        </AppBar>



                        <Formsy
                            onValidSubmit={this.onSubmit}
                            onValid={this.enableButton}
                            onInvalid={this.disableButton}
                            ref={(form) => this.form = form}
                            className="flex flex-col justify-center"
                        >
                            <fieldset className="mt-8 mr-16  p-8 pb-16 ">
                                {/* <div className="block">
                                    <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                        <div className="block" >Date</div>
                                        <TextFieldFormsy
                                            className="block"
                                            type="date"
                                            name='date'
                                            value={this.state.date}
                                            //defaultValue={this.state.latePaymentMonthlyCharge}
                                            className={classes.textField}
                                            // onChange={this.handleDateChange('date')}
                                            //margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>

                                    <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                        <div className="block" >Document Number</div>
                                        <TextFieldFormsy
                                            className="block"
                                            name='doc_number'
                                            //value={this.state.latePaymentMonthlyCharge}
                                            //defaultValue={this.state.latePaymentMonthlyCharge}
                                            className={classes.textField}

                                            //margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                </div>
                                <Divider className="mt-16" /> */}
                                <div className="block mt-8">

                                    <div className="w-full sm:w-1/2 md:w-1/4 px-8  inline-block">
                                        <div className="block" >Transaction Date</div>
                                        <TextFieldFormsy
                                            className="block"
                                            type="date"
                                            name='transaction_date'
                                            value={this.state.transaction_date}
                                            //defaultValue={this.state.latePaymentMonthlyCharge}
                                            className={classes.textField}
                                            // onChange={this.handleTransactionDateChange('transaction_date')}
                                            //margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    <div className="w-full sm:w-1/2 md:w-1/4 px-8  inline-block">
                                        <div className="block" >Reference Number</div>
                                        <TextFieldFormsy
                                            className="block"
                                            id="referance_no"
                                            name="referance_no"
                                            //value={this.state.latePaymentMonthlyCharge}
                                            //defaultValue={this.state.latePaymentMonthlyCharge}
                                            className={classes.textField}
                                            //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                            //margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>

                                    <div className="w-full sm:w-1/2 md:w-1/4 px-8  inline-block">
                                        <div className="block" >Due Date</div>
                                        <TextFieldFormsy
                                            className="block"
                                            type="date"
                                            name='due_date'
                                            value={this.state.due_date}

                                            defaultValue={this.state.today}
                                            className={classes.textField}
                                            // onChange={this.handleDueDateChange('due_date')}
                                            //margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>

                                     <div className="w-full sm:w-1/2 md:w-1/4 px-8  inline-block">
                                        <div className="block" >Amount</div>
                                        <TextFieldFormsy
                                            className="block"
                                            id="amount"
                                            name="amount"
                                            //value={this.state.latePaymentMonthlyCharge}
                                            //defaultValue={this.state.latePaymentMonthlyCharge}
                                            className={classes.textField}
                                            //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                            //margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>


                                </div>
                                <div className="block mt-8">

                                    <div className="w-full sm:w-1/2 md:w-1/4 px-8  inline-block">
                                        Supplier(Expenses)
                                        <Select
                                            className="w-full"
                                            style={{ margintop: '200px' }}
                                            name="form-field-name"
                                            placeholder="Select Supplier"
                                            value={this.state.supplier}
                                            onChange={this.handleLedgerSupplier}
                                            options={this.state.supplierArray}
                                        />
                                    </div>

                                    <div className="w-full sm:w-1/2 md:w-1/4 px-8  inline-block">
                                        Ledger Account
                                <Select
                                            className="w-full"
                                            style={{ margintop: '200px' }}
                                            name="form-field-name"
                                            placeholder="Select Ledger Account"
                                            value={this.state.ledgerAcc}
                                            onChange={this.handleLedgerAcc}
                                            options={this.state.ledgerAccArray}
                                        />
                                    </div>

                                    {/* <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                    <div className="block" >Ledger Account</div>
                                    <TextFieldFormsy
                                        className="block"
                                        id="ledger_account"
                                        name="ledger_account"
                                        //value={this.state.latePaymentMonthlyCharge}
                                        //defaultValue={this.state.latePaymentMonthlyCharge}
                                        className={classes.textField}
                                        //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                        //margin="normal"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div> */}
                                   
                                </div>
                                <DialogActions className="justify-right pl-16 ">
                                    <Button
                                        variant="raised"
                                        color="secondary"
                                        className="mx-16 mt-16 pb-15"
                                        aria-label="Save"
                                        type="submit"
                                    //disabled={!canSubmit}
                                    >
                                        Save
                            </Button>

                                    <Button
                                        variant="raised"
                                        color="primary"
                                        className="mx-16 mt-16 pb-15"
                                        aria-label="Clear"
                                        onClick={this.clearValue}
                                    //disabled={!canSubmit}
                                    >
                                        Clear
                            </Button>

                                    <Button
                                        variant="raised"
                                        color="primary"
                                        className="mx-16 mt-16 pb-15"
                                        aria-label="Help"
                                    //disabled={!canSubmit}
                                    >
                                        Help
                            </Button>
                                </DialogActions>

                            </fieldset>
                        </Formsy>

                    </Dialog>

                   
                    <ReactTable
                        data={this.state.data}
                        columns={[

                            {
                                Header: "Document No. ",
                                className: "justify-start",
                                accessor: "doc_number"
                            },
                            {
                                Header: "Reference No.",
                                className: "justify-start",
                                accessor: "ref_number",
                                width: 200
                            },
                            {
                                Header: "Supplier",
                                className: "justify-start",
                                accessor: "supplier_name"
                            },
                            {
                                Header: "Ledger Account",
                                className: "justify-start",
                                accessor: "ledger_account_name"
                            },
                            {
                                Header: "Amount",
                                className: "justify-start",
                                accessor: "amount"

                            },
                            {
                                Header: "Due Date",
                                className: "justify-start",
                                accessor: "due_date"

                            },

                            // {
                            //     Header: "Status",
                            //     accessor: "status",
                            //     maxWidth: 200,
                            //     className: "justify-center",
                            //     Cell: row => (

                            //         <div className="flex items-center">
                            //             <Icon
                            //                 className={row.original.active === 'Active' ? 'text-green-light'
                            //                     : row.original.active === 'Inactive' ? 'text-red-light'
                            //                         : 'text-orange-light'}
                            //                 title={row.original.active === 'Active' ? 'Active'
                            //                     : row.original.active === 'Inactive' ? 'Inactive'
                            //                         : 'text-orange-light'}
                            //             >
                            //                 {row.original.active === 'Active' ? 'check_circle'
                            //                     : row.original.active === 'Inactive' ? `cancel`
                            //                         : 'Other'}
                            //             </Icon>

                            //         </div>
                            //     )

                            // },
                            {
                                Header: "Action",
                                maxWidth: 100,
                                className:"justify-center",
                                // accessor: "su",
                                width: 128,
                                Cell: row => (
                                    <div className="flex items-center w-8 h-8">
                                        <IconButton

                                            onClick={(e) => {
                                                if (row) {
                                                    // alert(row.original.accountType)
                                                    id = row.original.update_id;
                                                    doc_number = row.original.doc_number;
                                                    ref_number = row.original.ref_number;
                                                    date = row.original.date;
                                                    due_date = row.original.due_date;
                                                    transaction_date = row.original.transaction_date;
                                                    supplier = row.original.supplier;
                                                    supplier_name = row.original.supplier_name;
                                                    ledger_account_id = row.original.ledger_account_id;
                                                    ledger_account_name = row.original.ledger_account_name;
                                                    amount = row.original.amount;
                                                    is_active = row.original.is_active;



                                                    this.setState({
                                                        supplierEdit: supplier,
                                                        supplierNameEdit:supplier_name,
                                                        ledgerAccEdit: ledger_account_id,
                                                        ledgerAccEditName: ledger_account_name
                                                    });

                                                    // this.setState({ isActiveEdit: row.original.is_active });

                                                    this.setState({ edit: true });
                                                }
                                                // alert(mainAccountId)
                                            }}

                                        >
                                            <Icon className="text-blue" title="Edit">mode_edit</Icon>
                                        </IconButton>
                                        <Dialog

                                            open={this.state.edit}
                                            onClose={this.handleCloseEdit}
                                            aria-labelledby="form-dialog-title"
                                            maxWidth="md"
                                            // classes={{ paper: classes.dialogPaper }}
                                            // fullScreen="true"
                                        >
                                            <Formsy
                                                onValidSubmit={this.onEdit}
                                                onValid={this.enableButtonEdit}
                                                onInvalid={this.disableButtonEdit}
                                                ref={(form) => this.form = form}
                                                className=""
                                            >
                                                <DialogTitle id="form-dialog-title">Edit Bill Entry Details</DialogTitle>
                                                <DialogContent className="flex flex-wrap">

                                                    <div className="w-full ">


                                                        <TextFieldFormsy
                                                            type="hidden"
                                                            name="id"
                                                            value={id}
                                                        />
                                                        {/* <div className="block">
                                                            <div className="w-full sm:w-1/2 md:w-1/3 px-8  inline-block">
                                                                <div className="block" >Date</div>
                                                                <TextFieldFormsy
                                                                    className="block"
                                                                    type="date"
                                                                    name='date'
                                                                    value={date}
                                                                    //defaultValue={this.state.latePaymentMonthlyCharge}
                                                                    className={classes.textField}
                                                                    //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                                                    //margin="normal"
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                            </div>

                                                            <div className="w-full sm:w-1/2 md:w-1/3 px-8  inline-block ml-32">
                                                                <div className="block" >Documnet Number</div>
                                                                <TextFieldFormsy
                                                                    className="block"
                                                                    name='doc_number'
                                                                    value={doc_number}
                                                                    //defaultValue={this.state.latePaymentMonthlyCharge}
                                                                    className={classes.textField}
                                                                    //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                                                    //margin="normal"
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <Divider className="mt-16" /> */}
                                                        <div className="block mt-8">

                                                            <div className="w-full sm:w-1/2 md:w-1/4 px-8  inline-block">
                                                                <div className="block" >Transaction Date</div>
                                                                <TextFieldFormsy
                                                                    className="block"
                                                                    type="date"
                                                                    name='transaction_date'
                                                                    value={transaction_date}
                                                                    //defaultValue={this.state.latePaymentMonthlyCharge}
                                                                    className={classes.textField}
                                                                    //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                                                    //margin="normal"
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="w-full sm:w-1/2 md:w-1/4 px-8  inline-block">
                                                                <div className="block" >Referance Number</div>
                                                                <TextFieldFormsy
                                                                    className="block"
                                                                    id="referance_no"
                                                                    name="referance_no"
                                                                    value={ref_number}
                                                                    //defaultValue={this.state.latePaymentMonthlyCharge}
                                                                    className={classes.textField}
                                                                    //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                                                    //margin="normal"
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                            </div>

                                                            <div className="w-full sm:w-1/2 md:w-1/4 px-8  inline-block ">
                                                                <div className="block" >Due Date</div>
                                                                <TextFieldFormsy
                                                                    className="block"
                                                                    type="date"
                                                                    name='due_date'
                                                                    value={due_date}
                                                                    //defaultValue={this.state.latePaymentMonthlyCharge}
                                                                    className={classes.textField}
                                                                    //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                                                    //margin="normal"
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                            </div>

                                                              <div className="w-full sm:w-1/2 md:w-1/4 px-10  inline-block">
                                                                <div className="block" >Amount</div>
                                                                <TextFieldFormsy
                                                                    className="block"
                                                                    id="amount"
                                                                    name="amount"
                                                                    value={amount}
                                                                    //defaultValue={this.state.latePaymentMonthlyCharge}
                                                                    className={classes.textField}
                                                                    //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                                                    //margin="normal"
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                            </div>


                                                        </div>
                                                        <div className="block mt-8">

                                                            <div className="w-full sm:w-1/2 md:w-1/3 px-8  inline-block">
                                                                Supplier(Expences)
                                                                <Select
                                                                    className=""
                                                                    name="form-field-name"
                                                                    placeholder="Select Supplier"
                                                                    value={this.state.supplierEdit}
                                                                    onChange={this.handleLedgerSupplierEdit}
                                                                    options={this.state.supplierArray}
                                                                />
                                                            </div>

                                                            <div className="w-full sm:w-1/2 md:w-1/3 px-8  inline-block">
                                                                Ledger Account
                                                                <Select
                                                                    className="block"
                                                                    name="form-field-name"
                                                                    placeholder="Select Supplier"
                                                                    value={this.state.ledgerAccEdit}
                                                                    onChange={this.handleLedgerAccEdit}
                                                                    options={this.state.ledgerAccArray}
                                                                />
                                                            </div>

                                                           
                                                          
                                                        </div>
                                                    </div>

                                                </DialogContent>
                                                <DialogActions>

                                                     <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:h-24 mx-16 mt-16 pb-15 default-btn-size ">
                                                        Update
                                                                        </Button>

                                                    <Button type="button" onClick={this.handleCloseEdit} variant="raised" size="small" color="primary" className="{classes.button} w-full mx-16 mt-16 pb-15 md:h-24 default-btn-size">
                                                        Close
                                                                        </Button>
                                                  
                                                </DialogActions>
                                            </Formsy>
                                        </Dialog>
                                    </div>
                                )
                            }
                        ]}
                        //pageSize={this.state.records.length>3?this.state.records.length:3}
                        defaultPageSize={10}
                        className="-striped -highlight"
                    />
                </div>
            )


        }
    }

    handleSaveClick() {
        console.log('Save pre validations billdate', this.state.billDate);
        var billDate;
        /* if(this.state.billDate==''){
                            billDate = moment(new Date()).format("YYYY-MM-DD");
                        }else{
                            billDate = this.state.billDate
                        } */
        if (this.state.billDate == undefined) {

            confirmAlert({
                title: 'Bill Date', message: 'Select a valid bill date',
                buttons: [{ label: 'Ok' }]
            })
            return;
        }


        var discountGiven = this.state.sumValues.isDiscountPercentage ?
            parseFloat(this.state.sumValues.grossAmount) * parseFloat(this.state.sumValues.discount) / 100
            : this.state.sumValues.discount;

        if (this.state.customerPrivilageDiscount && parseFloat(parseFloat(this.state.customerPrivilageDiscount).toFixed(2)) < parseFloat(parseFloat(discountGiven).toFixed(2))) {

            confirmAlert({
                title: 'Item price', message: 'Customer discount privilage limit exceeded. Limit is ' + parseFloat(this.state.customerPrivilageDiscount).toFixed(2),
                buttons: [{ label: 'Ok' }]
            })
            return;
        }

        if (this.state.isQuotation) {
            this.createQuotation();
        }
        else {
            this.createInvoice();
        }
    }

}

export default withStyles(styles, { withTheme: true })(withAlert(BillEntries));





// WEBPACK FOOTER //
// ./src/main/content/accounting/billEntries/BillEntries.js